module.exports = __webpack_public_path__ + "media/images/users/about_online_purchase.en-34b8a5aad3bbd0a5143cffb659230c76.png";